<template>
  <div class="articlelist-container">
    <a-row>
      <a-col :span="2">
        <bread-crumb />
      </a-col>
      <a-col :span="22">
        <table-search
          style="float: right"
          @onSearch="onSearch"
          @onChangeCompany="onChangeCompany"
          @onChangeType="onChangeType"
          @onChangeStatus="onChangeStatus"
          @editAndAdd="editAndAdd"
          @onExport="onExport"
          @onStartTime="onStartTime"
          @onEndTime="onEndTime"
          @onExportTask="onExportTask"
          @onExportRepresent="onExportRepresent"
        />
      </a-col>
    </a-row>
    <div class="global-table-container">
      <div class="recommend-btn-container">
        <a-button
          type="danger"
          class="recommend-btn"
          :loading="delLoading"
          @click="handleDelete"
        >
          删除
        </a-button>
        <span v-show="isShowError" class="errorMsg">请至少选择一项</span>
      </div>

      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="(record) => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: (total) => `共${total}条`,
        }"
        :row-selection="{
          selectedRowKeys,
          onChange: onchangeCheck,
        }"
        @change="changePage"
      >
        <template slot="feedback_count" slot-scope="text, record">
          <a href="javascript:;" @click="() => onFeed(record)">{{
            record.feedback_count
          }}</a>
        </template>
        <template slot="promoter" slot-scope="text, record">
          <a href="javascript:;" @click="() => checkPromoter(record)">查看</a>
        </template>
        <template slot="task" slot-scope="text, record">
          <a href="javascript:;" @click="() => checkResource(record)">查看</a>
        </template>
        <template slot="operation" slot-scope="text, record">
          <a href="javascript:;" @click="() => exportTask(record)">进度</a>
          <a-divider type="vertical" />
          <a href="javascript:;" @click="() => workReport(record)">报告</a>
          <a-divider type="vertical" />
          <a href="javascript:;" @click="() => handleReview(record)">详情</a>
          <a-divider type="vertical" />
          <a href="javascript:;" @click="() => editAndAdd(record)">编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
    <promoter-modal
      :data="promoterData"
      :visible="promoterVisible"
      @onCancel="cancelPromoter"
    >
      <form-button
        submit-text="确定"
        :show-msg="false"
        @onCancel="cancelPromoter"
        @onSubmit="cancelPromoter"
      />
    </promoter-modal>
    <resource-modal
      :data="resourceData"
      :visible="resourceVisible"
      @onCancel="cancelResource"
    >
      <form-button
        submit-text="确定"
        :show-msg="false"
        @onCancel="cancelResource"
        @onSubmit="cancelResource"
      />
    </resource-modal>
  </div>
</template>
<script>
import { columnsCompany, columnsService } from "./data/index";
import TableSearch from "./components/search";
import promoterModal from "./modal/promoterModal";
import resourceModal from "./modal/resourceModal";
export default {
  components: { TableSearch, promoterModal, resourceModal },
  data() {
    return {
      columns: [],
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
      btnIsLoading: false,
      title: "",
      visible: false,
      id: "",
      isShowError: false,
      selectedRowKeys: [],
      delLoading: false,
      keyword: undefined,
      company_id: 0,
      task_type: 0,
      task_status: 0,
      polymorphic_type: "1",
      start_time: undefined,
      end_time: undefined,
      companyData: [],
      promoterData: [],
      promoterVisible: false,
      resourceData: [],
      resourceVisible: false,
      token: "",
    };
  },
  async mounted() {
    this.token = localStorage.getItem("token");
    if (this.$store.state.user.role === 1) {
      this.columns = columnsService;
    } else {
      this.columns = columnsCompany;
    }
    // 获取合作企业
    await this.getCompanyList();
    // 获取表格数据
    await this.getTableData({
      page: 1,
      pageSize: this.pageSize,
      keyword: this.keyword,
      task_status: this.task_status,
      cooperation_company_id: this.company_id,
      task_type: this.task_type,
      start_time: this.start_time ? this.$Date(this.start_time) : undefined,
      end_time: this.end_time ? this.$Date(this.end_time) : undefined,
    });
  },
  methods: {
    // 获取合作企业   服务商
    async getCompanyList() {
      let result = await this.$http.post("/Company/getCooperationCompanyList");
      if (result.data.status === 1) {
        this.company_id = result.data.data.data_list[0].id;
        let data = result.data.data.data_list.map((item) => {
          return { name: item.companyInfo.qichacha_name, ...item };
        });
        this.companyData = data;
      }
    },
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post("/task/getList", params);
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            company_name: item.company_name,
            admin_name: item.admin_name,
            admin_area: item.admin_area,
            task_name: item.task_name,
            task_type_name: item.task_type_name,
            time: `${this.$moment
              .unix(item.start_time)
              .format("YYYY-MM-DD")}~${this.$moment
              .unix(item.end_time)
              .format("YYYY-MM-DD")}`,
            // time: `${this.$Format(item.start_time)}~${this.$Format(item.end_time)}`,
            create_time: item.create_time,
            score: item.score,
            feedback_count: item.feedback_count,
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;
        console.log("getTableData -> temp", temp);
      }
    },
    // 查看推广员
    async checkPromoter(record) {
      console.log("checkPromoter -> record", record);
      this.promoterVisible = true;
      let result = await this.$http.post("/task/getTaskPromoters", {
        task_id: record.id,
      });
      if (result.data.status === 1) {
        let data = result.data.data.data_list;
        this.promoterData = data;
      }
    },
    async exportTask(record) {
      window.location.href = `${this.uploadUrl}task/exportTaskDetailInfoNew?task_ids=${record.id}&token=${this.token}`;
    },
    async workReport(record) {
      window.location.href = `${this.uploadUrl}task/workReportExportWord?task_id=${record.id}&token=${this.token}`;
    },

    // 取消查看推广员
    cancelPromoter() {
      this.promoterVisible = false;
    },
    // 查看资料
    async checkResource(record) {
      this.resourceVisible = true;
      let result = await this.$http.post("/task/getTaskDatas", {
        task_id: record.id,
      });
      if (result.data.status === 1) {
        let data = result.data.data.data_list;
        this.resourceData = data;
      }
    },
    // 取消查看资料
    cancelResource() {
      this.resourceVisible = false;
    },
    // 查看反馈数
    onFeed(record) {
      console.log("onFeed -> record", record);
      this.$router.push({
        path: "/promotefeed",
        query: { id: record.id, company_id: record.data.company_id },
      });
    },
    // 审核
    handleReview(record) {
      this.$router.push({ path: "/task/check", query: { id: record.id } });
    },
    // 编辑或新增
    editAndAdd(record) {
      if (record) {
        // this.data=record;
        this.$router.push({ path: "/task/edit", query: { id: record.id } });
      } else {
        this.$router.push({ path: "/task/add" });
      }
    },
    // 确定编辑或新增
    onSubmit() {
      this.$refs.hospitalModalForm.$refs.basicForm.form.validateFields(
        async (err, values) => {
          if (!err) {
            console.log(values);
            this.btnIsLoading = true;
            let result = await this.$http.post("/task/update", {
              type: this.type,
              id: this.id,
              ...values,
            });
            this.btnIsLoading = false;
            if (result.data.status === 1) {
              this.$message.success("操作成功！");
              this.getTableData({
                page: 1,
                pageSize: this.pageSize,
                keyword: this.keyword,
                cooperation_company_id: this.company_id,
                task_status: this.task_status,
                task_type: this.task_type,
                start_time: this.start_time
                  ? this.$Date(this.start_time)
                  : undefined,
                end_time: this.end_time ? this.$Date(this.end_time) : undefined,
              });
            }
          }
        }
      );
    },
    // 取消编辑或新增
    onCancel() {
      this.visible = false;
    },
    // 搜索
    onSearch(value) {
      this.current = 1;
      this.keyword = value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        keyword: this.keyword,
        cooperation_company_id: this.company_id,
        task_status: this.task_status,
        task_type: this.task_type,
        start_time: this.start_time ? this.$Date(this.start_time) : undefined,
        end_time: this.end_time ? this.$Date(this.end_time) : undefined,
      });
    },
    // 选择状态
    onChangeStatus(value) {
      this.current = 1;
      this.task_status = value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        keyword: this.keyword,
        cooperation_company_id: this.company_id,
        task_status: this.task_status,
        task_type: this.task_type,
        start_time: this.start_time ? this.$Date(this.start_time) : undefined,
        end_time: this.end_time ? this.$Date(this.end_time) : undefined,
      });
    },
    // 选择类型
    async onChangeType(value) {
      this.current = 1;
      this.task_type = value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        keyword: this.keyword,
        cooperation_company_id: this.company_id,
        task_status: this.task_status,
        task_type: this.task_type,
        start_time: this.start_time ? this.$Date(this.start_time) : undefined,
        end_time: this.end_time ? this.$Date(this.end_time) : undefined,
      });
    },
    // 选择公司
    onChangeCompany(value) {
      this.current = 1;
      this.company_id = value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        cooperation_company_id: this.company_id,
        keyword: this.keyword,
        task_status: this.task_status,
        task_type: this.task_type,
        start_time: this.start_time ? this.$Date(this.start_time) : undefined,
        end_time: this.end_time ? this.$Date(this.end_time) : undefined,
      });
    },
    // 选择开始时间
    onStartTime(value) {
      this.current = 1;
      this.start_time = value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        cooperation_company_id: this.company_id,
        keyword: this.keyword,
        task_status: this.task_status,
        task_type: this.task_type,
        start_time: this.start_time ? this.$Date(this.start_time) : undefined,
        end_time: this.end_time ? this.$Date(this.end_time) : undefined,
      });
    },
    // 选择结束时间
    onEndTime(value) {
      this.current = 1;
      this.end_time = value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        cooperation_company_id: this.company_id,
        keyword: this.keyword,
        task_status: this.task_status,
        task_type: this.task_type,
        start_time: this.start_time ? this.$Date(this.start_time) : undefined,
        end_time: this.end_time ? this.$Date(this.end_time) : undefined,
      });
    },
    // 导出任务详情
    async onExport() {
      if (this.$store.state.user.role === 1) {
        if (!this.company_id) {
          this.$message.warning("请选择企业！");
          return;
        }
        window.location.href = `${
          this.uploadUrl
        }/task/adminTaskExport?drug_id=${this.company_id}
        &start_time=${
          this.start_time ? this.$Date(this.start_time) : ""
        }&end_time=${this.end_time ? this.$Date(this.end_time) : ""}
       &task_type=${this.task_type ? this.task_type : ""}&task_status=${
          this.task_status ? this.task_status : ""
        }&keyword=${this.keyword ? this.keyword : ""}
       &token=${this.token}`;
      } else {
        window.location.href = `${this.uploadUrl}/task/adminTaskExport?
       task_type=${this.task_type ? this.task_type : ""}&task_status=${
          this.task_status ? this.task_status : ""
        }&keyword=${this.keyword ? this.keyword : ""}
       &start_time=${
         this.start_time ? this.$Date(this.start_time) : ""
       }&end_time=${this.end_time ? this.$Date(this.end_time) : ""}
       &token=${this.token}`;
      }
    },
    // 导出任务统计
    onExportTask() {
      if (this.$store.state.user.role === 1) {
        if (!this.company_id) {
          this.$message.warning("请选择企业！");
          return;
        }
        window.location.href = `${
          this.uploadUrl
        }/task/exportTaskCount?drug_id=${this.company_id}
        &start_time=${
          this.start_time ? this.$Date(this.start_time) : ""
        }&end_time=${this.end_time ? this.$Date(this.end_time) : ""}
       &task_type=${this.task_type ? this.task_type : ""}&task_status=${
          this.task_status ? this.task_status : ""
        }&keyword=${this.keyword ? this.keyword : ""}
       &token=${this.token}`;
      } else {
        window.location.href = `${this.uploadUrl}/task/exportTaskCount?
       task_type=${this.task_type ? this.task_type : ""}&task_status=${
          this.task_status ? this.task_status : ""
        }&keyword=${this.keyword ? this.keyword : ""}
       &start_time=${
         this.start_time ? this.$Date(this.start_time) : ""
       }&end_time=${this.end_time ? this.$Date(this.end_time) : ""}
       &token=${this.token}`;
      }
    },
    // 导出代表统计
    onExportRepresent() {
      if (this.$store.state.user.role === 1) {
        if (!this.company_id) {
          this.$message.warning("请选择企业！");
          return;
        }
        window.location.href = `${
          this.uploadUrl
        }/task/exportTaskDetail?drug_id=${this.company_id}
        &start_time=${
          this.start_time ? this.$Date(this.start_time) : ""
        }&end_time=${this.end_time ? this.$Date(this.end_time) : ""}
       &task_type=${this.task_type ? this.task_type : ""}&task_status=${
          this.task_status ? this.task_status : ""
        }&keyword=${this.keyword ? this.keyword : ""}
       &token=${this.token}`;
      } else {
        window.location.href = `${this.uploadUrl}/task/exportTaskDetail?
       task_type=${this.task_type ? this.task_type : ""}&task_status=${
          this.task_status ? this.task_status : ""
        }&keyword=${this.keyword ? this.keyword : ""}
       &start_time=${
         this.start_time ? this.$Date(this.start_time) : ""
       }&end_time=${this.end_time ? this.$Date(this.end_time) : ""}
       &token=${this.token}`;
      }
    },
    // 删除单个
    async onDelete(record) {
      let result = await this.$http.post("/task/del", { id: record.id });
      if (result.data.status === 1) {
        this.$message.success("操作成功！");
        this.getTableData({
          page: this.current,
          pageSize: this.pageSize,
          keyword: this.keyword,
          cooperation_company_id: this.company_id,
          task_status: this.task_status,
          task_type: this.task_type,
          start_time: this.start_time ? this.$Date(this.start_time) : undefined,
          end_time: this.end_time ? this.$Date(this.end_time) : undefined,
        });
      }
    },
    // check表格
    onchangeCheck(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
    },
    // 批量删除
    async handleDelete() {
      if (this.selectedRowKeys.length === 0) {
        this.isShowError = true;
        return;
      }
      this.delLoading = true;
      let result = await this.$http.post("/task/moreDel", {
        ids: this.selectedRowKeys,
      });
      this.delLoading = false;
      if (result.data.status === 1) {
        this.$message.success("操作成功！");
        this.selectedRowKeys = [];
        this.isShowError = false;
        this.getTableData({
          page: this.current,
          pageSize: this.pageSize,
          keyword: this.keyword,
          cooperation_company_id: this.company_id,
          task_status: this.task_status,
          task_type: this.task_type,
          start_time: this.start_time ? this.$Date(this.start_time) : undefined,
          end_time: this.end_time ? this.$Date(this.end_time) : undefined,
        });
      }
    },
    // 分页
    changePage(pagination) {
      this.current = pagination.current;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        keyword: this.keyword,
        cooperation_company_id: this.company_id,
        task_status: this.task_status,
        task_type: this.task_type,
        start_time: this.start_time ? this.$Date(this.start_time) : undefined,
        end_time: this.end_time ? this.$Date(this.end_time) : undefined,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.articlelist-container {
  .recommend-btn-container {
    margin-bottom: 10px;
    .recommend-btn {
      margin-right: 10px;
    }
    .errorMsg {
      color: red;
      font-size: 16px;
      margin-left: 10px;
    }
  }
}
</style>
